export class ImportVO {
    order = NaN;
    type;
    url;
    namespace;
    location;
    attributes;
    category;
    owner;
    exists = false;
    failed = false;
    event;
    constructor(type, url, namespace = undefined, location = window, attributes = undefined, category = undefined, owner = undefined) {
        this.type = type;
        this.url = url;
        this.namespace = namespace;
        this.location = location;
        this.attributes = attributes;
        this.exists = false;
        this.failed = false;
        this.event = undefined;
        this.category = category;
        this.owner = owner;
    }
    get name() {
        return 'ImportVO';
    }
}
